import { Component, Input, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import {
    ChartComponent,
    ApexAxisChartSeries,
    ApexChart,
    ApexXAxis,
    ApexDataLabels,
    ApexYAxis,
    ApexLegend,
    ApexFill,
    NgApexchartsModule,
    ApexGrid,
} from 'ng-apexcharts';

export type ChartOptions = {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    xaxis: ApexXAxis;
    dataLabels: ApexDataLabels;
    yaxis: ApexYAxis;
    colors: string[];
    stroke: any; // ApexStroke;
    grid: ApexGrid;
    legend: ApexLegend;
    fill: ApexFill;
};

@Component({
    selector: 'app-tickets-solved-and-cleated',
    standalone: true,
    imports: [
        MatCardModule,
        MatMenuModule,
        MatButtonModule,
        NgApexchartsModule,
    ],
    templateUrl: './tickets-solved-and-cleated.component.html',
    styleUrl: './tickets-solved-and-cleated.component.scss',
})
export class TicketsSolvedAndCleatedComponent {
    @ViewChild('chart') chart: ChartComponent;
    public chartOptions: Partial<ChartOptions>;

    @Input() data: any = {
        name: '',
        categories: [],
        series: [],
    };

    constructor() {
        this.chartOptions = {
            series: this.data.series,
            chart: {
                type: 'area',
                height: 396,
                stacked: true,
                toolbar: {
                    show: true,
                },
            },
            colors: ['#796df6', '#00cae3'],
            dataLabels: {
                enabled: false,
            },
            stroke: {
                width: [4, 4],
            },
            fill: {
                type: 'gradient',
                gradient: {
                    opacityFrom: 0.1,
                    opacityTo: 0.6,
                },
            },
            legend: {
                offsetY: 0,
                fontSize: '14px',
                position: 'top',
                horizontalAlign: 'center',
                labels: {
                    colors: '#919aa3',
                },
                itemMargin: {
                    horizontal: 12,
                    vertical: 12,
                },
            },
            grid: {
                strokeDashArray: 5,
                borderColor: '#e0e0e0',
            },
            xaxis: {
                categories: this.data.categories,
                axisBorder: {
                    show: false,
                    color: '#e0e0e0',
                },
                axisTicks: {
                    show: false,
                    color: '#e0e0e0',
                },
                labels: {
                    show: true,
                    style: {
                        colors: '#919aa3',
                        fontSize: '14px',
                    },
                },
            },
            yaxis: {
                tickAmount: 5,
                labels: {
                    show: true,
                    style: {
                        colors: '#919aa3',
                        fontSize: '14px',
                    },
                },
            },
        };
    }

    // changeData
    changeData() {
        if (this.chartOptions.xaxis) {
            this.chartOptions.xaxis.categories = this.data.categories;
        }
        this.chartOptions.series = this.data.series;
    }
}
